import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { createExitMttStagingToLoungeOutbound } from '../../api/outbound/mttStagingOutbounds';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { DrawerButton } from '../../drawer/drawerButton';
import { DrawerControl, PaddedDrawerContainer } from '../../drawer/drawerControl';
import { ArrowTopLeftThickIcon } from '../../icons/arrowTopLeftThickIcon';
export const MttStagingDrawerControl = () => {
    const socketSend = useSocketSend();
    const onClickExitRoom = useCallback(() => {
        socketSend(createExitMttStagingToLoungeOutbound());
    }, [socketSend]);
    return (_jsx(DrawerControl, { render: (closeDrawer) => (_jsx(PaddedDrawerContainer, { isHighlighted: true, children: _jsx(DrawerButton, { label: 'Exit Room', onClick: () => {
                    onClickExitRoom();
                    closeDrawer();
                }, startIcon: _jsx(ArrowTopLeftThickIcon, {}), variant: 'contained', size: 'large' }) })) }));
};
